var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full h-full pt-5"},[_vm._m(0),_c('div',{staticClass:"w-full flex"},[_c('SettingsMenu',{staticClass:"mx-2"})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex"},[_c('h1',{staticClass:"text-xl text-left font-extrabold ml-4 mt-3 mr-8"},[_vm._v(" Settings ")])])
}]

export { render, staticRenderFns }